import { render, staticRenderFns } from "./event_details_link.vue?vue&type=template&id=01a81675&"
import script from "./event_details_link.vue?vue&type=script&lang=js&"
export * from "./event_details_link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports